/* @jsxImportSource @emotion/react */
import React from 'react'

import { Avatar } from '../../Avatar/Avatar'
import { fontSize } from './constants'
import type { ArticleAuthor } from './types'

const AVATAR_OVERLAP = -10

const avatarCss = {
  border: '2px solid var(--moon-dust-lighter)',
  boxSizing: 'content-box',
} as const

// The avatars repeat the names printed right next to them, so they are
// decorative — announcing them again is noise.
export function ArticleAuthors(props: {
  authors: ArticleAuthor[]
  label?: string
}) {
  if (props.authors.length === 0) {
    return null
  }

  const names = props.authors.map((author) => author.name).join(', ')

  return (
    <div className="flexbox flexbox-align-center flexbox-gap-12">
      <div
        className="flexbox-inline flexbox-align-center flexbox-no-shrink"
        aria-hidden="true"
      >
        {props.authors.map((author, index) => (
          <Avatar
            key={`${author.name}-${index}`}
            name={author.name}
            photoUrl={author.imageUrl}
            size="large"
            css={avatarCss}
            style={{
              marginLeft: index > 0 ? AVATAR_OVERLAP : 0,
              // First author on top, unlike AvatarGroup.
              zIndex: props.authors.length - index,
            }}
          />
        ))}
      </div>
      <div className="min-width-zero">
        {props.label && (
          <div
            className="shade-20 line-height-small"
            css={{ fontSize: fontSize.tiny, paddingBottom: 6 }}
          >
            {props.label}
          </div>
        )}
        <div
          className="shade-05 font-weight-semibold"
          css={{ fontSize: fontSize.small }}
        >
          {names}
        </div>
      </div>
    </div>
  )
}
